import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import {
  getProductLanguages,
} from 'reduxpath/ducks/ProductLanguage/List'

import {
  updateProductLanguage,
  setLoadState,
  setData,
} from 'reduxpath/ducks/ProductLanguage/Edit'

import Edit from './units'

const mapStateToProps = state => ({
  data: state.ProductLanguageEdit.data,
})

const mapDispatchToProps = dispatch => ({

  handleFormChange(data) {
    return (e) => {
      const params = {
        data: {
          id: data.id,
          name: e.target.name === 'name'
            ? e.target.value
            : data.name,
        },
      }
      dispatch(setData(params))
    }
  },

  handleCancel() {
    browserHistory.push('/product_languages')
  },

  editProductLanguage(data) {
    return (e) => {
      e.preventDefault()

      dispatch(setLoadState(true))

      const updatedProductLanguage = {
        id: data.id,
        name: data.name,
      }

      dispatch(updateProductLanguage(updatedProductLanguage, data.id, () => {
        dispatch(getProductLanguages())
        dispatch(setLoadState(false))

        browserHistory.push('/product_languages')
      }))
    }
  },
})


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Edit)
